import { useRouter } from 'expo-router';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import {
  NavigationButton,
  NavigationButtonTypes,
} from '@/components/navigation-button';
import { Button, Text } from '@/ui';

interface CarsListedModalProps {
  visible?: boolean;
  onClose: () => void;
  style?: any;
}

export function CarsListedModal({
  visible = false,
  onClose,
  style,
}: CarsListedModalProps) {
  const { styles, theme } = useStyles(stylesheet);
  const router = useRouter();
  const [showModal, setShowModal] = useState(visible);

  useEffect(() => {
    setShowModal(visible);
  }, [visible]);

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={300}
      isVisible={showModal}
      hasBackdrop
      style={{
        ...styles.container,
        ...style,
      }}
      onBackdropPress={() => {
        setShowModal(false);
        onClose?.();
      }}
    >
      <View style={styles.containerView}>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: 16,
          }}
        >
          <View>
            <Text type="title2">Your Car(s) Are Listed!</Text>
          </View>

          <NavigationButton
            type={NavigationButtonTypes.cancel}
            onPress={() => {
              setShowModal(false);
              onClose?.();
            }}
            style={{
              position: 'absolute',
              right: 16,
              top: 16,
            }}
          />
        </View>

        <View style={{ padding: 16, gap: 24 }}>
          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            Your cars are now listed! Don't forget to review your car details.
            To do this, go to Cars → Select your vehicle → Click Setup/Edit. You
            can customize pricing, availability, booking rules, and more
          </Text>
        </View>

        <View
          style={{
            padding: 16,
            paddingTop: 0,
            gap: 24,
          }}
        >
          <Button
            text="Go To Cars"
            type="primary"
            onPress={() => {
              setShowModal(false);
              onClose();
            }}
            style={styles.button}
          />
        </View>
      </View>
    </Modal>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    margin: 0,
    paddingBottom: {
      xs: 16,
      md: 0,
    },
    justifyContent: 'center',
    alignSelf: 'center',
    maxWidth: {
      xs: '100%',
      sm: 600,
    },
    width: {
      xs: '100%',
    },
  },
  containerView: {
    backgroundColor: theme.colors.background_2,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    gap: 24,
    borderRadius: 16,
    borderBottomLeftRadius: {
      xs: 0,
      md: 16,
    },
    borderBottomRightRadius: {
      xs: 0,
      md: 16,
    },
  },
  button: {
    width: {
      xs: '100%',
      md: 150,
    },
  },
}));
